const detachMarker = (marker) => {
  if (typeof marker?.setMap === 'function') {
    marker.setMap(null);
    return;
  }

  if (marker) marker.map = null;
};

/**
 * MarkerClusterer replaces group markers as the viewport changes, but its
 * normal redraw path only removes the old marker from the map. Clear the
 * Google event listeners as well so repeated map interactions cannot retain
 * superseded cluster markers and their DOM content.
 */
export const releaseSupersededClusterMarkers = (
  previousClusters = [],
  currentClusters = [],
) => {
  const retainedMarkers = new Set(
    currentClusters.map((cluster) => cluster?.marker).filter(Boolean),
  );

  previousClusters.forEach((cluster) => {
    const marker = cluster?.marker;
    const isGroupMarker = (cluster?.markers?.length || 0) > 1;
    if (!marker || !isGroupMarker || retainedMarkers.has(marker)) return;

    window.google?.maps?.event?.clearInstanceListeners?.(marker);
    detachMarker(marker);
  });
};
